import { inject, Injectable, Injector, Type } from '@angular/core';
import { SystemEntity } from '@wdx/shared/utils';
import { AmlriskDuplicatesApiService } from '../services';

@Injectable({ providedIn: 'root' })
export class EntityTypeDuplicatesResolverService {
    private readonly injector = inject(Injector);

    private serviceMap: Partial<Record<SystemEntity, Type<any>>> = {
        [SystemEntity.AmlRisk]: AmlriskDuplicatesApiService,
    };

    getService(entityType: SystemEntity) {
        const serviceType = this.serviceMap[entityType];
        if (!serviceType) {
            return null;
        }

        return this.injector.get(serviceType);
    }
}
